module.exports = __webpack_public_path__ + "img/sort.3cba95c6.svg";